import React from 'react'
import styled from 'styled-components'
import { last } from 'ramda'
import FaCircle from 'react-icons/lib/fa/circle'
import { Title } from '../common/styled'
import { Wrapper, Text } from './shared'

export const ExpertiseWrapped = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 0 0 0;
`

export const CircleIcon = styled(FaCircle)`
  color: ${props => props.theme.colors.gold};
  margin: 8px;
  padding: 3px;
`

export default ({ data, name, count }) => {
  const lastItem = last(data)
  return (
    <Wrapper count={count} noHeight>
      <Title pl='0px'>EXPERTISE</Title>
      <ExpertiseWrapped>
        {data.map(item => (
          <Text fw='600' key={item.name}>{item.name}{item !== lastItem && <CircleIcon />}</Text>
        ))}
      </ExpertiseWrapped>
    </Wrapper>
  )
}
